import { useContext, useEffect, useMemo, useState } from "react";
import './map-tabs.scss'
import { LocationsContext } from "../map-artworks";
import { GrSearchAdvanced } from "react-icons/gr";
import { FaPlaceOfWorship } from "react-icons/fa";
import { FaMagnifyingGlassLocation} from "react-icons/fa6";
import { FaMapMarkedAlt } from "react-icons/fa";
import { ArtworkGallery } from "../../commons/artwork-gallery/artwork-gallery";
import { ArtworksService } from "../../../services/artworksService";
import { AppList } from "../../app-list/app-list";
import { TopListService } from "../../../services/topListService";
import { MapLocationSearch } from "../map-location-search/map-location-search";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "../../../utils/constants/languages";
import { LanguageContext } from "../../../providers/LanguageProvider";


export function MapTabs(){

    const lang = useContext(LanguageContext);
    const locationObject = useContext(LocationsContext);
    const [tabSelected,setTabSelected]=useState('');
    const [artWorkList,setArtworkList]=useState([]);
    const [displayTabContent,setDisplayTabcontent]=useState(true);
    const [topList,setTopList]=useState<any>([]);
    const [translatedSelectedLocation,setTranslatedSelectedLocation]=useState<any>(null);
    const [translatedTopList,setTranslatedTopList]=useState<any>([]);
    const {t}=useTranslation();

    useEffect(()=>{

        if(!locationObject?.selectedLocation){
            setTabSelected("advanced_search");
            return;
        }else{
            setTabSelected("detailed_view");
            const locationSelectedId = locationObject.selectedLocation.id;
            translateLocation(locationObject.selectedLocation)
            ArtworksService().getItemByLocation(locationSelectedId).then(
                (artworks:any)=>{
                    setArtworkList(artworks.data);
                }
            ).catch((err)=>console.error(err))
        }

    },[locationObject?.selectedLocation,lang]);
    
    useEffect(()=>{
        TopListService().getAll().then(
            (locations:any)=>{
                setTopList(locations.data);
            }
        ).catch((err)=>console.error(err))
    },[]);


    useMemo(()=>{
        if(!topList.length){
            return null
        }else{

            const localLanguage =LANGUAGES.find((language) => language.code === lang.language)?.locale ?? lang.language;
            if (localLanguage === 'fr-FR'){
                setTranslatedTopList(topList);
            }else{
                const newSelectedLocation = topList.map((elem:any)=>{
                    const newElem = elem.location.translations?.find((elt:any)=>elt.languages_code=== localLanguage); 
                    return{
                        location:{
                            ...elem.location,
                            name:newElem?newElem.name:elem.name   
                        }
                    }
                })
                setTranslatedTopList(newSelectedLocation);
            } 
        }
    },[lang,topList]);


    function tabSelect(name:string){
        if(name!=='map'){
            setDisplayTabcontent(true)
        }else{
            setDisplayTabcontent(false)
        }
        setTabSelected(name)
    }


    function translateLocation(selectedLocation:any){

        const localLanguage =LANGUAGES.find((language) => language.code === lang.language)?.locale ?? lang.language;
        if (localLanguage === 'fr-FR'){
            setTranslatedSelectedLocation(selectedLocation);
        }else{
            const newSelectedLocation = selectedLocation.translations?.find((elt:any)=>elt.languages_code== localLanguage);
            setTranslatedSelectedLocation({
                ...selectedLocation,
                description:newSelectedLocation?.description,
                name:newSelectedLocation?.name
            });
        }   
    }

   
    return(
        <div>
            
            <ul className="tab-header">
                <li  className={`map-result-location nav-map-tab-item ${tabSelected==='detailed_view'?'active':''}`} onClick={()=>tabSelect('detailed_view')}>
                    <a><FaPlaceOfWorship/> {t('map_view.details_view')}</a>
                </li>
                <li className={`map-result-location nav-map-tab-item ${tabSelected==='advanced_search'?'active':''}`} onClick={()=>tabSelect('advanced_search')}>
                    <a><GrSearchAdvanced/> {t('advanced_search')}</a>
                </li>
                
                <li className="mobile-map-only" onClick={()=>tabSelect('map')}>
                    <a><FaMapMarkedAlt/> {t("map.label")}</a>
                </li>
            </ul>
            <div className={`tab-content ${displayTabContent?"show-mobile":"hide-mobile"}`}>
                {tabSelected ==='detailed_view'?
                    <div className={`map-result-content ${locationObject?.selectedLocation?'':'empty'}`}>

                       {locationObject?.selectedLocation?(
                        <>

                       <div className="location-infos">
                        {translatedSelectedLocation?(
                            <>
                            <h2> {translatedSelectedLocation?.name}</h2>   
                            <div className="intro-container">
    
                                {locationObject?.selectedLocation?.cover_image?
                                <figure className="img-float">
                                    <img src={
                                        typeof locationObject.selectedLocation?.cover_image === 'object'
                                        ? `/api/assets/${locationObject.selectedLocation.cover_image.id}?key=location-thumbnail`
                                        : `/api/assets/${locationObject.selectedLocation.cover_image}?key=location-thumbnail`
                                    }
                                    alt={translatedSelectedLocation.name}
                                    title={translatedSelectedLocation.name}/>
                                </figure>:
                                ''}
                                <p className="location-descr">
                                    {translatedSelectedLocation.description}
                                </p>  
                            </div>
                            </>
                        ):''}
                        </div>
                        <div className="line-after-location"></div>
                        {(artWorkList.length==0)?"":
                        <div className="canvases-container">
                            <h4> {t("map_view.location_artwork", {count:artWorkList.length})}</h4>
                            <ArtworkGallery list={artWorkList} withCaption={true}/>
                        </div>
                        }

                        </>):
                        <>
                            <div className="no-location-selected-container ">
                                <FaMagnifyingGlassLocation  size={70} />
                                <p>{t("map_view.no_location_selected")}</p>
                                <p>{t("map_view.select_location")}</p>
                            </div>
                        </>
                        
                        }

                    </div>
                :""}

                {tabSelected==='advanced_search'?
                    <div className="map-result-advanced-search-content">
                        <form>
                            <MapLocationSearch/>
                        </form>
                        {topList?.length==0?'':
                        <div className="toplist-container">
                            <h4>{t('map_view.toplist')}</h4>
                            <AppList list={translatedTopList}/>
                        </div>
                        }
                    </div>
                :""}
            </div>
        </div>
    )
}